import { compose } from 'recompose';

import ButtonsControlGroup from './buttonsControlGroup';

const enhance = compose();
export default enhance(ButtonsControlGroup);
